import { Spacing, RadioGroup } from "@mindlercare/ui-web";
import { useTranslation } from "react-i18next";
import { Typography } from "components/typography";

type GenderSectionProps = {
  value: string | null;
  setGender: (gender: string) => void;
  psychologistValidation: string[];
};

export const GenderSection = ({
  value,
  setGender,
  psychologistValidation,
}: GenderSectionProps) => {
  const { t } = useTranslation();
  const hasError = psychologistValidation.includes("gender");
  return (
    <div>
      <Typography
        variant="body-x-small"
        color={hasError ? "ERROR" : "GRAY_DARK"}
        insensitive
      >
        {`${t("GENDER")}*`}
      </Typography>

      <Spacing t={12} />

      <RadioGroup
        defaultValue={value ?? undefined}
        aria-labelledby="psychologist-genderlabel"
        onChange={(currentValue) => {
          setGender(currentValue);
        }}
      >
        <RadioGroup.RadioButton name="M">
          <span>{t("MAN")}</span>
        </RadioGroup.RadioButton>
        <RadioGroup.RadioButton name="F">
          <span>{t("WOMAN")}</span>
        </RadioGroup.RadioButton>
        <RadioGroup.RadioButton name="O">
          <span>{t("OTHER")}</span>
        </RadioGroup.RadioButton>
      </RadioGroup>
    </div>
  );
};
